<template>
  <div class="element-box p-0">
    <div v-show="forbidden" class="alert alert-warning mb-0">
      <span>Üzgünüz, bu işlemi yapmak için yeterli yetkiniz bulunmuyor.</span>
    </div>

    <template v-if="!forbidden">
      <div class="alert alert-success mb-0" v-if="registeredData">
        <span v-text="type === 'update' ? t.custom_reseller_panel.client_updated : t.custom_reseller_panel.client_created"></span>
        <p class="lead mt-1">{{ t.user.username }}:
          <b><code>{{ registeredData.username }}</code></b>
          <br>{{ t.user.password }}: <b><code>{{ registeredData.signature }}</code></b>
        </p>

        <textarea id="infop" style="width: 100%">
          {{ t.user.username }}: {{ registeredData.username }}
          {{ t.user.password }}: {{ registeredData.signature }}
        </textarea>

        <a class="btn btn-block btn-success register-btn" target="_blank" :href="'https://api.whatsapp.com/send?text='+t.user.username+': '+registeredData.username+' '+ t.user.password +': '+registeredData.signature">
          {{ t.custom_reseller_panel.whatsapp_share}}
        </a>
        <a class="btn btn-block btn-primary register-btn" :href="'tg://msg?text=Kullanıcı adı: '+registeredData.username+' '+t.user.password+': '+registeredData.signature" title="inviteFriends" alt="telegram_share">
          {{ t.custom_reseller_panel.telegram_share}}
        </a>


      </div>
      <div class="element-content p-3" v-if="!registeredData">
        <h6 class="element-header capitalize" v-text="type === 'update' ? t.edit : t.create_user"></h6>
        <symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess"
                 v-if="userForm"/>
      </div>
    </template>



  </div>
</template>

<script>
import symForm from '@/components/form/symForm.vue'

export default {
  name: 'register',
  components: {symForm},
  props: ['type', 'userType'],
  data() {
    return {
      session: session,
      userLoader: true,
      t: this.$root.t,
      users: null,
      regions: [],
      breadcrumb: [],
      userOpened: false,
      userForm: null,
      formProcess: 0,
      opt: {
        region: {data: [], label: 'nationallity'},
      },
      formData: [],
      registeredData: null,
      forbidden: false
    }
  },
  mounted() {
    this.getUserForm();
  },
  notifications: {
    showFormError: { // You can have any name you want instead of 'showLoginError'
      title: 'Login Failed',
      message: 'Failed to authenticate',
      type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
    }
  },
  methods: {
    async getUserForm(data) {

      this.userForm = null;
      this.formProcess = 0;
      this.$bus.$emit('globalLoader', true);
      if (data) {
        var ref = (this.$route.query.ref) ? this.$route.query.ref : '';
        //this.userForm = null;
        this.$http.post(api + 'api/v1/user/registration/form?userType=' + this.userType,
            data)
            .then(response => {

              this.registeredData = response.body.data;
              this.userForm = response.body.result;
              this.formProcess = 200;


              setTimeout(() => {

                var copyText = document.getElementById("infop");

                /* Select the text field */
                copyText.select();
                copyText.setSelectionRange(0, 99999); /* For mobile devices */

                /* Copy the text inside the text field */
                navigator.clipboard.writeText(copyText.value);
              }, 500);

              //swal('', this.t.registration.success, "success")
              this.$bus.$emit('globalLoader', false);

              if (response.body.data) {
                //this.$router.replace({name: 'CustomerDetail', params: {id: response.body.data.userId}})
              }

              this.getUserForm()

            }, response => {
              this.userForm = response.body.result;
              this.formProcess = 400;
              swal(this.t.processing.error, this.t.processing.check, "error")
              this.$bus.$emit('globalLoader', false);
            })

      } else {
        this.$http.get(api + 'api/v1/user/registration/form?userType='+this.userType)
            .then(response => {

              this.userForm = response.body.result;
              this.formData = response.body.form_data;
              this.opt.region.data = this.regions;
              this.opt.region.label = 'name';
              this.$bus.$emit('globalLoader', false);

            }, response => {
              this.$bus.$emit('globalLoader', false);
              this.forbidden = true;
            })
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/views/registration.vue